<template>
  <div id="app">
    <input-number v-model="value" :max="100" :min="0" :step="10"></input-number>
  </div>
</template>
<script>
import inputNumber from './components/inputNumber';
export default {
  components:{
    inputNumber
  },
  data(){
    return{
      value:5
    }
  },
  
}
</script>
